<div class="form-control input input-with-text input-date icon icon-calendar single">
  <input
    id="txtCalendarPolicyDate"
    type="text"
    name="calPolicyDate"
    data-type="daterange"
    readonly
    placeholder="Selecciona fechas"
    class="text-input inline text-09-d-demibold"
    [class.error]="validationUiService.isInsuredSubmit && !validationUiService.isPolicyStartRealDate(contractType)" />
</div>
